(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/exclusion-view.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/exclusion-view.js');
'use strict';

const {
  ListItem
} = svs.ui.ReactListGroup;
const ExclusionView = _ref => {
  let {
    exclusions
  } = _ref;
  return React.createElement(React.Fragment, null, React.createElement("h2", {
    className: "align-center f-700 f-bold"
  }, "Aktiva spelpauser"), React.createElement("div", {
    className: "header-container"
  }, React.createElement("h3", null, "Produkt"), React.createElement("h3", null, "Pausen g\xE4ller till och med:")), React.createElement("ul", {
    className: "exclusion-pause-wrapper list-item"
  }, exclusions.map(exclusion => React.createElement(ListItem, {
    "aria-label": "Produkt: ".concat(exclusion.subSystem, ", Pausen g\xE4ller till och med: ").concat(exclusion.textFormatDate),
    className: "list-item",
    key: exclusion.subSystem
  }, React.createElement("span", {
    className: "f-capitalize f-medium"
  }, exclusion.subSystem), React.createElement("span", {
    className: "right animate animate-show"
  }, exclusion.textFormatDate))), React.createElement("span", {
    className: "f-capitalize f-bold"
  })));
};
svs.selfExclusion.components.ExclusionView = ExclusionView;

 })(window);